import { Injectable, Signal, computed, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { cloneDeep } from 'lodash';
import { TReducerState } from '../../app.config';
import { userActions } from '../../state/user/user.actions';
import { TItemsComponentPageConfiguration } from '../../state/user/user.interface';
import { TItemScope, TItemsComponentItemScopeConfiguration } from './items-filter-card/items-filter-card.interface';

@Injectable({ providedIn: 'root' })
export class ItemsScopePreferenceService {
  private readonly globalStore: Store<TReducerState> = inject(Store);
  private readonly user = this.globalStore.selectSignal((state: TReducerState) => state.user.user);

  public readonly itemScope: Signal<TItemScope> = computed(() => {
    const configurations: TItemsComponentPageConfiguration[] = this.user()?.pageConfiguration?.ItemsComponent ?? [];
    const itemScopeConfiguration = configurations.find(
      (configuration): configuration is TItemsComponentItemScopeConfiguration => configuration.name === 'itemScope',
    );

    return itemScopeConfiguration?.value ?? 'family';
  });

  public setItemScope(itemScope: TItemScope): void {
    const componentConfigurations: TItemsComponentPageConfiguration[] =
      cloneDeep(this.user()?.pageConfiguration?.ItemsComponent)?.filter(
        (configuration) => configuration.name !== 'itemScope',
      ) ?? [];

    this.globalStore.dispatch(
      userActions.updateUserConfigurations({
        omitSuccessToast: true,
        pageConfiguration: {
          ...(this.user()?.pageConfiguration ?? {}),
          ItemsComponent: [...componentConfigurations, { name: 'itemScope', value: itemScope }],
        },
      }),
    );
  }
}
